<template>
  <div :ref="'refNotificationSettings'">
    <section v-if="settingsLoaded">
      <single-setting
        id="delivery-time"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Time.svg')"
        :title="$t('deliveryTime')"
        :description="$t('notficationsSelectTime')"
      >
        <dropdown
          id="dropdown-start"
          :title="$t('deliveryFrom')"
          :options="hoursFrom"
          dbname="notify-start-time"
          :value="notifyStartTimeStr"
          :type="'time'"
          @saved-to-db="rerenderTo"
        />
        <dropdown
          id="dropdown-end"
          :key="toDropdownKey"
          :title="$t('deliveryTo')"
          :options="hoursTo"
          dbname="notify-end-time"
          :type="'time'"
          :value="notifyEndTimeStr"
          @saved-to-db="changeEndNotify"
        />
      </single-setting>
      <single-setting
        id="followed"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Followed.svg')"
        :title="$t('followed')"
        :description="$t('notficationsConfFollowedDescr')"
      >
        <template>
          <p class="description">
            {{ $t('notifyMeAbout') }}
          </p>
          <toggle class="main-toggle" :name="$t('peopleFollowed')" :value="followNotifications" @toggled="toggleAllFollowNotifications" />

          <transition name="slide">
            <div v-if="followNotifications" class="secondary-toggles">
              <toggle
                v-for="(el, index) in followNotificationSettings()"
                :key="index + 'followKey'"
                class="toggle"
                :name="el.name"
                :dbname="el.key"
                :watchlist-id="watchlistId"
                :value="settings[el.key]"
                @toggled="valueToggled(el)"
              />
            </div>
          </transition>
        </template>
      </single-setting>
      <!-- <single-setting
        v-if="notificationTeams.length !== 0"
        id="team-notifications"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Team.svg')"
        :title="$t('team')"
        :description="descriptions.teamDesc"
      >
        <team-work-notification-toggles
          v-for="team in notificationTeams"
          :key="team.teamId"
          :single-team="team"
          class="team-notifications-group"
          @lock-scroll="scrollLock = !scrollLock"
        />
      </single-setting> -->

      <team-work-notification-toggles
        v-for="team in notificationTeams"
        :key="team.teamId"
        :ref="'notifSettings' + team.teamId"
        :single-team="team"
        class="team-notifications-group"
        :description="$t('notficationsConfigureDescr')"
        @lock-scroll="scrollLock = !scrollLock"
      />

      <!-- Weekly summaries TBD -->
      <!--
        <single-setting
        id="weekly-summaries"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Mail.svg')"
        :title="'Weekly Summaries'"
        :description="$t('summaryOfMostImportant')"
      >
        <template>
          <toggle
            class="toggle"
            :name="'On'"
            dbname="notify-email"
            :value="settings['notify-email']"
            @toggled="showSendSummary = !showSendSummary"
          />
          <dropdown
            v-show="showSendSummary"
            class="summaries-dropdown"
            :title="'Send Summaries Every'"
            :options="weekdays(1)"
            dbname="notify-day"
            :value="settings['notify-day']"
          />
        </template>
      </single-setting> -->
    </section>
  </div>
</template>

<script>
import Parse from 'parse'
import moment from 'moment'
import User from '@/components/User'
import Constants from '@/components/Constants'
import SingleSetting from '@/components/Settings/SingleSetting'
import Dropdown from '@/components/UI/Dropdown'
import Toggle from '@/components/UI/Toggle'
import TeamWorkNotificationToggles from '@/components/Team/TeamWorkNotificationToggles'
import ParseFunctions from '@/components/ParseFunctions'

export default {
  components: {
    SingleSetting,
    Dropdown,
    Toggle,
    TeamWorkNotificationToggles,
  },
  mixins: [User, Constants, ParseFunctions],
  data() {
    return {
      settings: null,
      settingsLoaded: false,
      showChangeEmail: false,
      showChangePassword: false,
      hours: [],
      hoursFrom: [],
      hoursTo: [],
      notifyStartTimeStr: '',
      notifyEndTimeStr: '',
      toDropdownKey: 0,
      showSendSummary: null,
      followNotifications: false,
      teams: undefined,
      notificationTeams: [],
      scrollLock: false,
      previousScroll: 0,
      watchlistId: undefined,
    }
  },
  async created() {
    this.watchlistId = Parse.User.current().get('watchlistId').id
    await this.load()

    if (!(this.$route.query && this.$route.query.teamId)) return

    let teamId = this.$route.query.teamId
    if (!this.notificationTeams.map((el) => el.teamId).includes(teamId)) return

    setTimeout(
      function () {
        this.$nextTick(function () {
          let wrapper
          let tabsHeaderHeight = 0

          if (window.innerWidth < 768) {
            wrapper = window
          } else {
            wrapper = document.getElementsByClassName('selected-tab')
            if (wrapper && wrapper.length > 0) wrapper = wrapper[0]
            else return

            let tabsHeader = document.querySelector('div.settings-top-menu.settings-header')
            if (tabsHeader) tabsHeaderHeight = tabsHeader.getBoundingClientRect().bottom
          }

          let teamSettings = this.$refs['notifSettings' + teamId][0].$el
          const OFFSET = -10 - tabsHeaderHeight
          wrapper.scroll({ top: teamSettings.getBoundingClientRect().top + OFFSET, behavior: 'smooth' })
        })
      }.bind(this),
      250,
    )
  },
  mounted() {
    this.$refs.refNotificationSettings.addEventListener('scroll', this.preventScroll)
  },
  beforeDestroy() {
    this.$refs.refNotificationSettings.removeEventListener('scroll', this.preventScroll)
  },
  methods: {
    async load() {
      let res = await this.userSettingsCLAPI(this.watchlistId)
      if (res.status === 'ok') {
        this.settings = res.settings

        let hourFormat = this.settings['is-24h'] ? 'HH:mm' : 'h:mm A'

        this.hours = this.hoursFormatWithFractions(this.settings['is-24h'], 2) // '12:00 AM' - '11:30 PM' every half hour
        this.notifyStartTimeStr = moment(this.settings['notify-start-time'], ['HH:mm']).format(hourFormat)
        this.notifyEndTimeStr = moment(this.settings['notify-end-time'], ['HH:mm']).format(hourFormat)
        this.showSendSummary = this.settings['notify-email']

        this.settingsLoaded = true

        let teamsRes = await this.getTeams()
        if (teamsRes.status === 'ok') {
          this.teams = teamsRes.teams
          this.notificationTeams = this.teams.filter((x) => this.role(x) !== 'base')

          this.fillHoursArrays() // prepare 2 arrays

          for (let i = 0; i < this.followNotificationSettings().length; i++) {
            if (this.settings[this.followNotificationSettings()[i].key]) this.followNotifications = true
          }
        } else {
          this.showServerError(teamsRes)
        }
      } else {
        this.showServerError(res)
      }
    },
    preventScroll() {
      if (this.scrollLock) {
        this.$refs.refNotificationSettings.scrollTop = this.previousScroll
      }
      this.previousScroll = this.$refs.refNotificationSettings.scrollTop
    },

    fillHoursArrays() {
      this.hoursFrom = this.hours.filter((x) => moment(x.value, 'HH:mm').isSameOrBefore(moment('22:30', 'HH:mm'))) // '12:00 AM' - '10:30 PM'
      this.hoursTo = this.hours.filter((x) =>
        moment(x.value, 'HH:mm').isSameOrAfter(moment(this.notifyStartTimeStr, this.settings['is-24h'] ? 'HH:mm' : 'h:mm A').add(1, 'hours')),
      ) // notifyStartTimeStr+1 - '11:30 PM'
    },
    async toggleAllFollowNotifications() {
      this.followNotifications = !this.followNotifications
      for (let setting of this.followNotificationSettings()) {
        await this.setWatchlistNotificationSetting(setting.key, this.followNotifications, this.watchlistId)
        this.settings[setting.key] = this.followNotifications
      }
    },
    valueToggled(el) {
      this.settings[el.key] = !this.settings[el.key]
    },

    async rerenderTo(teamIdUndefined, dbname, value) {
      this.notifyStartTimeStr = value
      // rerender 'To' dropdown after choice was made in 'From' dropdown
      let res = await this.userSettingsCLAPI(this.watchlistId)
      if (res.status === 'ok') {
        this.settings = res.settings
        let hourFormat = this.settings['is-24h'] ? 'HH:mm' : 'h:mm A'

        let start = moment(this.notifyStartTimeStr, hourFormat)
        let end = moment(this.notifyEndTimeStr, hourFormat)
        if (end.clone().add(-1, 'hours').isBefore(start)) {
          this.notifyEndTimeStr = moment(this.notifyStartTimeStr, hourFormat).add(1, 'hour').format(hourFormat)
          end = moment(this.notifyStartTimeStr, hourFormat)
        }

        let resStartTime = await this.setUserSetting('notify-start-time', start.format('HH:mm'))
        let resEndTime = await this.setUserSetting('notify-end-time', end.format('HH:mm'))

        // update values in store
        if (resStartTime.status === 'ok') {
          this.$store.commit('setOneUserSetting', { name: 'notify-start-time', value: start.format('HH:mm') })
        } else {
          this.showServerError(resStartTime)
        }
        if (resEndTime.status === 'ok') {
          this.$store.commit('setOneUserSetting', { name: 'notify-end-time', value: end.format('HH:mm') })
        } else {
          this.showServerError(resEndTime)
        }

        this.hoursTo = this.hours.filter((x) => moment(x.value, 'HH:mm').isSameOrAfter(moment(this.notifyStartTimeStr, hourFormat).add(1, 'hours'))) // notifyStartTimeStr+1 - '11:30 PM'
      } else {
        this.showServerError(res)
      }

      /** forcing dropdown refresh */
      this.toDropdownKey++
    },
    changeEndNotify(teamIdUndefined, dbname, value) {
      this.notifyEndTimeStr = value
      let valueToStore = this.settings['is-24h'] ? value : moment(value, 'h:mm A').format('HH:mm')
      this.$store.commit('setOneUserSetting', { name: 'notify-end-time', value: valueToStore })
    },
  },
}
</script>

<style lang="scss">
#followed {
  .slot.grid {
    grid-row-gap: 8px;
  }
}
</style>

<style lang="scss" scoped>
.summaries-dropdown {
  @include fade-in-opacity;

  &.hidden {
    pointer-events: none;
    @include fade-out-opacity;
  }
}

section {
  display: grid;
  grid-template-rows: auto auto auto;
  grid-row-gap: 60px;
  margin: 35px;

  // #delivery-time {
  //   grid-row: 1;
  // }
  #followed {
    grid-row: 2;
  }
  #delivery-time {
    grid-row: 1;
  }
}
.description {
  font-size: $font-size-caption;
  grid-column: span 3;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: $black;
  margin-top: 3px;
  margin-bottom: 4px;
}
#delivery-time-slot {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 60px;
  //grid-template-rows: auto;
  #dropdown-start {
    //grid-row: 1;
    grid-column: 1;
  }

  #dropdown-end {
    //grid-row: 1;
    grid-column: 2;
  }
}
#team-notifications {
  div {
    grid-column: span 2;
  }
}
#followed {
  .main-toggle {
    @include respond-below(sm) {
      margin-bottom: 0;
    }
  }
}
.single-setting {
  .main-toggle {
    grid-column: span 2;
  }
  .secondary-toggles {
    grid-row: 3;
    grid-column: span 2;
    display: grid;
    grid-column-gap: 60px;
    margin-left: 40px;
    @include respond-below(xs) {
      display: flex;
      flex-direction: column;
    }
    p {
      grid-column: span 2;
    }
    .toggle {
      grid-column-end: 2;
    }
  }
}
#weekly-summaries {
  .slot {
    display: grid;
    grid-template-rows: auto auto;
    grid-gap: 24px;

    div:nth-child(1) {
      grid-row: 1;
    }

    div:nth-child(2) {
      grid-row: 2;
    }
  }
}

.slot {
  display: flex;
  flex-direction: column;
  width: 220px;
}

@include respond-below(sm) {
  section {
    margin: 20px;
    margin-top: 35px;
  }
  .single-setting {
    //width: 322px;
  }

  .slot {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
</style>
